module.exports = __webpack_public_path__ + "img/category_cover_Novels.c0d1c24.webp";